export let MediaSupport = /*#__PURE__*/function (MediaSupport) {
  MediaSupport["MEDIA_DEVICES"] = "MEDIA_DEVICES";
  MediaSupport["ENUMERATE_MEDIA"] = "ENUMERATE_MEDIA";
  MediaSupport["USER_MEDIA"] = "USER_MEDIA";
  MediaSupport["DISPLAY_MEDIA"] = "DISPLAY_MEDIA";
  return MediaSupport;
}({});
export let MediaErrorType = /*#__PURE__*/function (MediaErrorType) {
  MediaErrorType["NOT_SUPPORTED_MEDIA_DEVICES"] = "NOT_SUPPORTED_MEDIA_DEVICES";
  MediaErrorType["NOT_SUPPORTED_ENUMERATE_MEDIA"] = "NOT_SUPPORTED_ENUMERATE_MEDIA";
  MediaErrorType["NOT_SUPPORTED_USER_MEDIA"] = "NOT_SUPPORTED_USER_MEDIA";
  MediaErrorType["NOT_CONSTRAINT_SATISFIED"] = "ConstraintNotSatisfiedError";
  MediaErrorType["NOT_FOUND_DEVICES"] = "NotFoundError";
  MediaErrorType["NOT_ALLOWED"] = "NotAllowedError";
  MediaErrorType["SECURITY_ERROR"] = "SecurityError";
  MediaErrorType["ABORT_ERROR"] = "AbortError";
  MediaErrorType["PERMISSION_DENIED"] = "PermissionDeniedError";
  MediaErrorType["OVERCONSTRAINED"] = "OverconstrainedError";
  return MediaErrorType;
}({});
export let MediaFacingMode = /*#__PURE__*/function (MediaFacingMode) {
  MediaFacingMode["USER"] = "user";
  MediaFacingMode["ENVIRONMENT"] = "environment";
  MediaFacingMode["LEFT"] = "left";
  MediaFacingMode["RIGHT"] = "right";
  return MediaFacingMode;
}({});
export let MediaTrackType = /*#__PURE__*/function (MediaTrackType) {
  MediaTrackType[MediaTrackType["AUDIO_OUTPUT"] = 0] = "AUDIO_OUTPUT";
  MediaTrackType[MediaTrackType["AUDIO_INPUT"] = 1] = "AUDIO_INPUT";
  MediaTrackType[MediaTrackType["VIDEO_INPUT"] = 2] = "VIDEO_INPUT";
  return MediaTrackType;
}({});
export let MediaRecordStatus = /*#__PURE__*/function (MediaRecordStatus) {
  MediaRecordStatus["INACTIVE"] = "inactive";
  MediaRecordStatus["RECORDING"] = "recording";
  MediaRecordStatus["PAUSED"] = "paused";
  return MediaRecordStatus;
}({});
export const mediaErrorType = (name, message) => {
  const error = new Error();
  error.name = name;
  error.message = message !== null && message !== void 0 ? message : '';
  return error;
};